import type { AxiosError } from "axios";

export type RichError<Failure> =
  | { type: "failure"; error: Failure }
  | { type: "axios"; error: AxiosError }
  | { type: "unknown"; error: unknown };

export const failure = <Failure>(error: Failure): RichError<Failure> =>
  ({ type: "failure", error }) as const;
export const axios: {
  (error: AxiosError): RichError<never>;
  <Failure>(error: AxiosError): RichError<Failure>;
} = (error: AxiosError) => ({ type: "axios", error }) as const;
export const unknown = (error: unknown): RichError<never> =>
  ({ type: "unknown", error }) as const;
